const initialState = {
  services: [
    {
      slug: 'hp-smart-tank-5000',
      cover: '/printers/5000.jpeg',
      thumbnail: '',
      title: 'HP Smart Tank 5000 Wireless All-in-One Ink Tank Printer',
      shortTitle: 'HP Smart Tank 5000 Wireless All-in-One Ink Tank Printer',
      price: 169,
      badge: '3 MONTHS',
      tags: ['High volume printing', 'Ethernet'],
      descrition:
        'HP Smart Tank 5000 Wireless All-in-One Ink Tank Printer, Scanner, Copier with 2 years of...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-laserjet-pro-m404dn',
      cover: '/printers/404dn.jpeg',
      thumbnail: '',
      title: 'HP LaserJet Pro M404dn Monochrome Laser Printer',
      shortTitle: 'HP LaserJet Pro M404dn Monochrome Laser Printer',
      price: 249,
      badge: '',
      tags: ['Print', 'Secure printing'],
      descrition:
        'Fast and reliable monochrome laser printer built for office productivity...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-envy-6555e',
      cover: '/printers/6555e.jpeg',
      thumbnail: '',
      title: 'HP Envy 6555e Wireless All-in-One Color Inkjet Printer',
      shortTitle: 'HP Envy 6555e Wireless All-in-One Color Inkjet Printer',
      price: 139,
      badge: '3 MONTHS',
      tags: ['Print', 'Scan', 'Copy'],
      descrition:
        'The Envy 6555e is perfect for home printing everyday documents, high quality photos, and...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-officejet-pro-9025e',
      cover: '/printers/9025e.jpeg',
      thumbnail: '',
      title: 'HP OfficeJet Pro 9025e Wireless All-in-One Printer',
      shortTitle: 'HP OfficeJet Pro 9025e Wireless All-in-One Printer',
      price: 329,
      badge: '',
      tags: ['Duplex', 'Wireless'],
      descrition:
        'High-performance inkjet printer ideal for small offices with fast speeds and advanced security...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-color-laserjet-pro-mfp-3301fdw',
      cover: '/printers/3301.webp',
      thumbnail: '',
      title:
        'HP Color LaserJet Pro MFP 3301fdw Wireless All-in-One Color Laser Printer',
      shortTitle:
        'HP Color LaserJet Pro MFP 3301fdw Wireless All-in-One Color Laser Printer',
      price: 539,
      badge: '',
      tags: ['Color printing', 'Multiuse', 'Wireless'],
      descrition:
        'Introducing a MOST TRUSTED PRINTER BRAND — Perfect for small home printing, scanning and copying...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-officejet-pro-8125e',
      cover: '/printers/8125e.jpeg',
      thumbnail: '',
      title: 'HP OfficeJet Pro 8125e Wireless All-in-One Color Inkjet Printer',
      shortTitle:
        'HP OfficeJet Pro 8125e Wireless All-in-One Color Inkjet Printer',
      price: 179,
      badge: '3 MONTHS',
      tags: ['Wireless printing', 'Multifunction', 'Compact design'],
      descrition:
        'The OfficeJet Pro 8125e is perfect for professional quality color documents like business...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'brother-work-smart-1360',
      cover: '/printers/1360.jpeg',
      thumbnail: '',
      title: 'Brother Work Smart 1360 Wireless Color Inkjet All-in-One Printer',
      shortTitle:
        'Brother Work Smart 1360 Wireless Color Inkjet All-in-One Printer',
      price: 109.99,
      badge: '',
      tags: ['Print', 'Copy', 'Scan'],
      descrition:
        'Get all your work done with an all-in-one multifunction printer. Print, copy, and scan...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-deskjet-4155e',
      cover: '/printers/4155e.jpeg',
      thumbnail: '',
      title: 'HP DeskJet 4155e Wireless All-in-One Printer',
      shortTitle: 'HP DeskJet 4155e Wireless All-in-One Printer',
      price: 99,
      badge: '',
      tags: ['Print', 'Scan', 'Copy', 'Print Printing'],
      descrition:
        'Affordable wireless printer designed for easy printing and scanning everyday...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-color-laserjet-pro-m255dw',
      cover: '/printers/m255d.jpeg',
      thumbnail: '',
      title: 'HP Color LaserJet Pro M255dw',
      shortTitle: 'HP Color LaserJet Pro M255dw',
      price: 389,
      badge: '',
      tags: ['Color Prnt', 'Wireless'],
      descrition:
        'Compact color laser printer delivering professional-quality color output...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-officejet-pro-9015e',
      cover: '/printers/9015e.jpeg',
      thumbnail: '',
      title: 'HP OfficeJet Pro 9015e All-in-One Printer',
      shortTitle: 'HP OfficeJet Pro 9015e All-in-One Printer',
      price: 279.99,
      badge: '3 MONTHS',
      tags: ['Print', 'Scan', 'Copy', 'Fax'],
      descrition:
        'The OfficeJet Pro 9015e is perfect for office printing professional quality color documents like presentations, brochures, the homework and...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-officejet-pro-8135e',
      cover: '/printers/3135e.jpeg',
      thumbnail: '',
      title: 'HP OfficeJet Pro 8135e Wireless All-in-One Color Inkjet Printer',
      shortTitle:
        'HP OfficeJet Pro 8135e Wireless All-in-One Color Inkjet Printer',
      price: 89.99,
      badge: '',
      tags: ['Wireless', 'Satellite printing'],
      descrition:
        'The OfficeJet Pro 8135e is perfect for home office printing professional quality color documents like business...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'hp-envy-6555e-wireless',
      cover: '/printers/655e.jpeg',
      thumbnail: '',
      title: 'HP Envy 6555e Wireless All-in-One Color Inkjet Printer',
      shortTitle: 'HP Envy 6555e Wireless All-in-One Color Inkjet Printer',
      price: 139,
      badge: '',
      tags: ['Print', 'Scan', 'Copy'],
      descrition:
        'Perfect for home printing everyday documents, high quality photos, and borderless photos, homework, and borderless photos...',
      services_included: [],
      faqs: [],
    },
    {
      slug: 'printer-setup',
      cover: '/images/printer-setup.jpg',
      thumbnail: '',
      title: 'Printer Setup ',
      price: 79,
      descrition:
        'Need help setting up a new printer or having trouble connecting to your printer? ITFixed247 has you covered. Our experts will connect your printer to a wireless network, adjust your print settings, connect your computer to the printer, show you how to print from all of your devices, and more!',
      services_included: [
        'Connect to wi-fi network if applicable',
        'Set up a local printer',
        'Configure and test printer functionality',
        'Demonstrate proper printer functionality',
      ],
      faqs: [
        {
          question: 'Does a data transfer or back-up take a long time?',
          answer:
            'The more data you have, the longer your service will take. If you have a very large amount of data, your tech may start the process and walk you through the remaining steps.',
        },
        {
          question: 'Do you offer a subscription service',
          answer:
            'IT Fixed 247 offers multiple membership plans to meet the ongoing needs of our customers. ',
        },
        {
          question: 'Do I have to use all of the services in the membership',
          answer:
            'All of the services included in our membership plans are strictly optional. Our principal objective is to help you keep your tech secure and simplify your life.',
        },
        {
          question: 'How long is the IT Fixed 247 membership plan',
          answer:
            'Your IT Fixed 247 Membership plan is good for one full year, and it is conveniently set to renew automatically. Members may turn off the auto renewal by logging onto their password-protected member portal and changing their settings. ',
        },
        {
          question: 'How do I request a service',
          answer: 'You can contact us via email at info@itfixed247.com   ',
        },
      ],
    },
    {
      slug: 'printer-installation',
      cover: '/images/printer-installation.jpg',
      thumbnail: '',
      title: 'Printer Installation',
      price: 89,
      descrition:
        'Need help setting up a new printer or having trouble connecting to your printer? ITFixed247 has you covered. Our experts will connect your printer to a wireless network, adjust your print settings, connect your computer to the printer, show you how to print from all of your devices, and more!',
      services_included: [
        'Connect to wi-fi network if applicable',
        'Set up a local printer',
        'Configure and test printer functionality',
        'Demonstrate proper printer functionality',
      ],
      faqs: [
        {
          question: 'Does a data transfer or back-up take a long time?',
          answer:
            'The more data you have, the longer your service will take. If you have a very large amount of data, your tech may start the process and walk you through the remaining steps.',
        },
        {
          question: 'Do you offer a subscription service',
          answer:
            'IT Fixed 247 offers multiple membership plans to meet the ongoing needs of our customers. ',
        },
        {
          question: 'Do I have to use all of the services in the membership',
          answer:
            'All of the services included in our membership plans are strictly optional. Our principal objective is to help you keep your tech secure and simplify your life.',
        },
        {
          question: 'How long is the IT Fixed 247 membership plan',
          answer:
            'Your IT Fixed 247 Membership plan is good for one full year, and it is conveniently set to renew automatically. Members may turn off the auto renewal by logging onto their password-protected member portal and changing their settings. ',
        },
        {
          question: 'How do I request a service',
          answer: 'You can contact us via email at info@itfixed247.com   ',
        },
      ],
    },
    {
      slug: 'printer-troubleshooting',
      cover: '/images/printer-troubleshooting.jpg',
      thumbnail: '',
      title: 'Printer Troubleshooting',
      price: 79,
      descrition:
        'Tired of printer jams, error messages, and connectivity problems with your printer? You need printer repair and support near you. ITFixed247 is in all 50 states and will send an expert printer technician to your door. ITFixed247 is the printer repair service you deserve for whatever printer help you need.',
      services_included: [
        'Troubleshoot printer issue',
        'Perform necessary printer repairs',
        'Ensure printer is functioning properly',
        'This service does not include the repair of physically damaged equipment. Additional costs can vary depending on a number of factors including, but not limited to, brand, degree of damage, extent of wiring and cost of additional parts required.',
      ],
      faqs: [
        {
          question: 'Should I have anything on hand for my service?',
          answer:
            'Please have paper available for test-printing and be sure the printer has ink!',
        },
        {
          question: 'What if a part inside my printer needs repair?',
          answer:
            'ITFixed247 does not repair hardware so if the problem requires replacement parts, we can only diagnose the issue.',
        },

        {
          question: 'How long is the IT Fixed 247 membership plan',
          answer:
            'Your IT Fixed 247 Membership plan is good for one full year, and it is conveniently set to renew automatically. Members may turn off the auto renewal by logging onto their password-protected member portal and changing their settings. ',
        },
        {
          question: 'How do I request a service',
          answer: 'You can contact us via email at info@itfixed247.com   ',
        },
      ],
    },
    {
      slug: 'wifi-and-network-connectivity',
      cover: '/images/wifi-networking.jpg',
      thumbnail: '',
      title: 'WiFi and Network Connectivity',
      price: 139,
      descrition:
        "Tired of slow and spotty internet? Our expert techs know how to speed up slow internet. We'll fix your network connection, boost your WiFi signal, and give you the fastest internet possible. Does your WiFi keep dropping out? We will fix your WiFi, establishing a stable, secure connection. Having trouble with your devices? We will connect all of your mobile and smart devices to your WiFi network and make everything work seamlessly.",
      services_included: [
        'Troubleshoot connectivity issues',
        'Install and configure network cards and wireless connections',
        'Ensure printer is functioning properly',
        'Configure and secure a router',
        'Create a secure network',
        'Coordinate setup preferences',
        'Connect peripheral devices to the wireless network',
      ],
      faqs: [
        {
          question: 'Should I have anything on hand for my service?',
          answer:
            "Just have your WiFi password as well as the login information for your router if possible. If you don't know your login, we can help figure it out.",
        },
        {
          question:
            "I'm not really sure what's wrong with my network. Is that ok?",
          answer:
            "Of course - That's why we're here! We'll check out your network and figure out how to improve whatever issues you're experiencing. If that involves a WiFi extension or anything that requires materials you don't have on hand, we can book a follow-up service.",
        },

        {
          question: 'How long is the IT Fixed 247 membership plan',
          answer:
            'Your IT Fixed 247 Membership plan is good for one full year, and it is conveniently set to renew automatically. Members may turn off the auto renewal by logging onto their password-protected member portal and changing their settings. ',
        },
        {
          question: 'How do I request a service',
          answer: 'You can contact us via email at info@itfixed247.com   ',
        },
      ],
    },
    {
      slug: 'set-up-a-new-wifi-connection',
      cover: '/images/wifi.jpg',
      thumbnail: '',
      title: 'New WiFi Connection Setup',
      price: 99,
      descrition:
        'Everything depends on a good WiFi connection, so let the experts set up your new WiFi connection just right. Our professionals know how to set up a router perfectly, connect your computer to the WiFi and all of your other devices to the wireless network as well. Feel the freedom and connectivity of a strong WiFi connection without the frustration of setting it up yourself. ',
      services_included: [
        'Configure and secure a router',
        'Create a secure network',
        'Coordinate setup preferences        ',
        'Configure and secure a router',
        'Install and configure wireless connections',
        'Coordinate setup preferences',
        'Connect peripheral devices to the wireless network',
      ],
      faqs: [
        {
          question:
            'My modem is located on one side of the house. Will my WiFi signal reach the other end? ',
          answer:
            'Your tech will identify the best possible location for your router, however walls and other obstructions can degrade the signal. If necessary, your tech may suggest adding a WiFi extender to your network to improve your WiFi coverage.',
        },
        {
          question: 'What is needed in order to set up a new WiFi connection?',
          answer:
            "First, you'll need to have a functioning internet connection provided by your Internet Service Provider such as AT&T, Spectrum or Verizon. You should already have a modem which provides internet access by connecting devices directly to your modem with ethernet cables. Some modems have built-in WiFi capabilities that can be utilized to create a WiFi network. If yours does not, you'll need a router that is capable of providing a reliable WiFi signal throughout your home.",
        },
      ],
    },
    {
      slug: 'extend-a-wifi-signal',
      cover: '/images/Wireless-Router-for-Home.jpg',
      thumbnail: '',
      title: 'WiFi Signal Extension',
      price: 129,
      descrition:
        "Don't be limited by your spotty WiFi signal. ITFixed247 can set up your WiFi repeater and WiFi booster extender to extend your WiFi range. Get connected in every room with a ITFixed247 WiFi Signal Extension service.",
      services_included: [
        'Troubleshoot connectivity issues',
        'Install and set up a WiFi extender (cost parts not included)',
        'Coordinate network preferences',
        'Connect peripheral devices to the network',
      ],
      faqs: [
        {
          question: 'Will I need more than 1 WiFi extender?',
          answer:
            "We'd need to assess your particular set up to know for sure. If your home is very large or your router is on one side of the house, you may want to have 2 extenders on hand just in case. If you need help in determining how many WiFi extenders you need, just let us know and we can help guide you prior to your appointment. Many customers prefer to book a WiFi Connectivity Support service first to diagnose the best solution for the optimal WiFi network. ",
        },
        {
          question: 'Should I have anything on hand for my service?          ',
          answer:
            "It's best to have a WiFi extender of choice available for your service. If you need help in selecting the right one, just let us know and we can help guide you prior to your appointment.            ",
        },
      ],
    },
    {
      slug: 'pc-optimization',
      cover: '/images/pcsetup.jpg',
      thumbnail: '',
      title: 'PC Optimization',
      price: 89,
      descrition:
        'Don´t we all clean up our rooms and shelves to get rid of the unwanted stuff? In the same manner it is essential that you regularly perform computer optimization on your system. This would help you get rid of all the unwanted files and data. The computer optimization program that we offer has the prime target to speed up the speed of your computer and enhance its performance. It would give your system a new life. In addition to this ourspecialized computer optimization service gives you the freedom to work uninterrupted on your system. After all you deserve the best.        ',
      services_included: [
        'Removing unwanted and junk files',
        'Removing unused and unwanted data',
        'Clearing temporary files',
        ' Updating security software',
        'Removing virus, spyware, malware and worms',
        'Complete PC scan',
        'Updating and configuring firewalls',
        'Timely and automatic updates',
      ],
      faqs: [
        {
          question: 'Do you offer a subscription service',
          answer:
            'IT Fixed 247 offers multiple membership plans to meet the ongoing needs of our customers. ',
        },
        {
          question: 'Do I have to use all of the services in the membership',
          answer:
            'All of the services included in our membership plans are strictly optional. Our principal objective is to help you keep your tech secure and simplify your life.',
        },
        {
          question: 'How long is the IT Fixed 247 membership plan',
          answer:
            'Your IT Fixed 247 Membership plan is good for one full year, and it is conveniently set to renew automatically. Members may turn off the auto renewal by logging onto their password-protected member portal and changing their settings. ',
        },
        {
          question: 'How do I request a service',
          answer: 'You can contact us via email at info@itfixed247.com   ',
        },
      ],
    },
    {
      slug: 'virus-removal-cleanup',
      cover: '/images/laptop-service.jpg',
      thumbnail: '',
      title: 'Virus Removal & Cleanup ',
      price: 79,
      descrition:
        'Viruses, spyware, and malware are often the cause of unusual and unpredictable computer behavior. If your computer is slow, freezing, or plagued with popups, your computer may be infected. But don’t worry, we know just how to clean up your computer and protect your privacy.        ',
      services_included: [
        'Troubleshoot one computer',
        'Perform a full-system sweep for all viruses, spyware, and malware',
        'Remove viruses, spyware, and malware if present',
        'Repair related OS issues',
        'Install supplied antivirus and antispyware software',
        'This service does not include data recovery/transfer services.',
        'Depending on the nature of your request we may be able to offer instant support through ITFixed247 Now! online assistance. An agent will create a secure connection to your computer and troubleshoot the issue right before your eyes.',
      ],
      faqs: [
        {
          question: "Doesn't a virus removal take a long time?",
          answer:
            'It can. We suggest booking a ITFixed247 Now! service. A tech will assess your computer remotely to perform your virus removal. If you prefer in-home service, that works for us. Just be aware that for very lengthy operations, your tech may start the process and walk you through the remaining steps.',
        },
        {
          question: 'Do I have to use all of the services in the membership',
          answer:
            'All of the services included in our membership plans are strictly optional. Our principal objective is to help you keep your tech secure and simplify your life.',
        },
        {
          question: 'How long is the IT Fixed 247 membership plan',
          answer:
            'Your IT Fixed 247 Membership plan is good for one full year, and it is conveniently set to renew automatically. Members may turn off the auto renewal by logging onto their password-protected member portal and changing their settings. ',
        },
        {
          question: 'How do I request a service',
          answer: 'You can contact us via email at info@itfixed247.com   ',
        },
      ],
    },
    {
      slug: 'new-computer-setup',
      cover: '/images/newsetup.jpg',
      thumbnail: '',
      title: 'New Computer Setup      ',
      price: 89,
      descrition:
        "Congratulations on your new computer! Excited to use your new PC or new Mac but wondering how to get started? You need a professional computer setup from ITFixed247. A professional tech will come to you and set up your computer: transfer your Microsoft Office, move your iTunes library over, sync your iPhone or other mobile devices, transfer your programs, show you where to find all of your files, and teach you how to use the new operating system. Don't be anxious about setting up your new computer. Let an expert from ITFixed247 get you up and running right away!",
      services_included: [
        'Perform system updates',
        'Remove unwanted programs',
        'Help setup user accounts',
        'Test hardware and software functionality',
        'Optimize computer startup',
        'Setup user profiles',
      ],
      faqs: [
        {
          question: 'Will my tech show me how to use my new computer?',
          answer:
            "Your tech will demonstrate that your computer is functioning properly and is ready for use. If you have a few specific questions, feel free to ask your tech. Don't know where to begin? For an hour of hands-on help, book a computer training session for just $89. Please understand that techs may not be knowledgeable about third-party software.",
        },
        {
          question: 'Do I have to use all of the services in the membership',
          answer:
            'All of the services included in our membership plans are strictly optional. Our principal objective is to help you keep your tech secure and simplify your life.',
        },
        {
          question: 'How long is the IT Fixed 247 membership plan',
          answer:
            'Your IT Fixed 247 Membership plan is good for one full year, and it is conveniently set to renew automatically. Members may turn off the auto renewal by logging onto their password-protected member portal and changing their settings. ',
        },
        {
          question: 'How do I request a service',
          answer: 'You can contact us via email at info@itfixed247.com   ',
        },
      ],
    },
    {
      slug: 'computer-repair',
      cover: '/images/wifi-networking.jpg',
      thumbnail: '',
      title: 'Computer Repair',
      price: 79,
      descrition:
        "Computer on the fritz? ITFixed247 is America's computer repair service company. Our experts will solve uncooperative software, unfriendly hard drives, and frustrating issues across both Windows and Mac operating systems. You're in good hands with ITFixed247 computer services.",
      services_included: [
        'Diagnose & troubleshoot a single issue        ',
        'NOTE: Requesting additional services not in the original request while on-site will result in extra charges',
        'Depending on the nature of your request we may be able to offer instant support through ITFixed247 Now! online assistance. An agent will create a secure connection to your computer and troubleshoot the issue right before your eyes.',
      ],
      faqs: [
        {
          question: "What do I do if I'm not really sure what the problem is?",
          answer:
            "That's why we're here! Some customers prefer to book a ITFixed247 Now! service. A tech will assess your computer remotely to either resolve the issue or to diagnose the problem. If your issue requires an in-home visit, we can schedule a follow-up service. ITFixed247 Now! is a great value, immediate and available 24x7.",
        },
        {
          question: 'Can you replace my hard drive?',
          answer:
            'ITFixed247 does not repair hardware so if the problem requires hard drive replacement, we can only diagnose the issue.',
        },
        {
          question: 'My computer is very old. Can you help?',
          answer:
            'We can definitely try, but repairing older machines can often end up being more costly than replacing the computer. If your computer is more than 4 years old, consider your options. And, if you need help setting up a new computer, ITFixed247 is here.',
        },
        {
          question: 'Can you help add memory to my computer?',
          answer:
            'Adding memory requires access to the inside of your computer. ITFixed247 does not provide hardware support so if the problem requires additional memory, we can only diagnose the issue.',
        },
      ],
    },
    {
      slug: 'computer-tuneup',
      cover: '/images/system-repair.jpg',
      thumbnail: '',
      title: 'Computer Tune-up',
      price: 35,
      descrition:
        "Do you find yourself asking, 'Why is my computer so slow?' It's a frustrating question, and we have the answers. If your PC or Mac computer is running slow, our techs can clean it up and make it run like new. Even new computers get bogged down with unnecessary files and unwanted programs. ITFixed247 can make your computer run better than new.",
      services_included: [
        'Increase speed and performance of your computer',
        'Perform system cleanup and defragmentation',
        'Get rid of any unnecessary programs',
        'Cleanup physical hardware',
        'Extra charges will apply in the event that virus removal is needed. You will be notified beforehand.',
        'Depending on the nature of your request we may be able to offer instant support through ITFixed247 Now! online assistance. An agent will create a secure connection to your computer and troubleshoot the issue right before your eyes.',
      ],
      faqs: [
        {
          question:
            'When should I book a tune-up versus a troubleshooting or repair service?',
          answer:
            "A tune-up is appropriate when your computer is properly functioning but seems a little sluggish. Many customers book regular tune-ups a few times a year - depending on your usage - to keep their computer in top-top shape. It's best to prevent problems rather than waiting until you have one to deal with.            ",
        },
        {
          question: 'Can you replace my hard drive?',
          answer:
            'ITFixed247 does not repair hardware so if the problem requires hard drive replacement, we can only diagnose the issue.',
        },
        {
          question: 'My computer is very old. Can you help?',
          answer:
            'We can definitely try, but repairing older machines can often end up being more costly than replacing the computer. If your computer is more than 4 years old, consider your options. And, if you need help setting up a new computer, ITFixed247 is here.',
        },
        {
          question: 'Can you help add memory to my computer?',
          answer:
            'Adding memory requires access to the inside of your computer. ITFixed247 does not provide hardware support so if the problem requires additional memory, we can only diagnose the issue.',
        },
      ],
    },
    {
      slug: 'data-backup-or-transfer',
      cover: '/images/jeffrey-abbott-desk-02.jpg',
      thumbnail: '',
      title: 'Data Back-up or Transfer',
      price: 129,
      descrition:
        "The experts at ITFixed247 can backup all your files to an external hardrive or to cloud storage, protecting your important files, no matter what. Need to transfer data to a new computer? Wondering how to transfer data from one computer to another? ITFixed247 has you covered, performing PC to PC data transfers or moving your files between PC and Mac computers. We'll handle every aspect of your data transfer, including local files and folders, items stored in Google drive or other Cloud storage, and data on an external hard drive.",
      services_included: [
        'Backup data to a CD or DVD - up to 10 GB',
        'Backup data to an external hard drive',
        'Backup data to the cloud',
        'This service does not include data recovery from damaged drives',
      ],
      faqs: [
        {
          question: 'Does a data transfer or back-up take a long time?',
          answer:
            'The more data you have, the longer your service will take. If you have a very large amount of data, your tech may start the process and walk you through the remaining steps.',
        },
        {
          question: 'Can you replace my hard drive?',
          answer:
            'ITFixed247 does not repair hardware so if the problem requires hard drive replacement, we can only diagnose the issue.',
        },
        {
          question: 'My computer is very old. Can you help?',
          answer:
            'We can definitely try, but repairing older machines can often end up being more costly than replacing the computer. If your computer is more than 4 years old, consider your options. And, if you need help setting up a new computer, ITFixed247 is here.',
        },
        {
          question: 'Can you help add memory to my computer?',
          answer:
            'Adding memory requires access to the inside of your computer. ITFixed247 does not provide hardware support so if the problem requires additional memory, we can only diagnose the issue.',
        },
      ],
    },
    {
      slug: 'operating-system-services',
      cover: '/images/img_5b68e80f77e33.png',
      thumbnail: '',
      title: 'OS (Operating System) Install or Re-install',
      price: 75,
      descrition:
        "Not happy with your version of Windows or Mac OS X? We can fix that for you! If you need to upgrade your operating system, or you already did and are desperate to go back, then just let us know we'll set you up with a Tech who can get everything running the way you want it.",
      services_included: [
        'Install or Re-install on operating system on one computer (OS discs are required and will not be supplied)',
        'Ensure that all necessary drivers have been installed',
        'Make sure system is up to date',
        'Verify the system is functioning properly',
        'NOTE: ITFixed247 cannot provide operating system software but only use the software provided by you.',
      ],
      faqs: [
        {
          question: 'Does a data transfer or back-up take a long time?',
          answer:
            'The more data you have, the longer your service will take. If you have a very large amount of data, your tech may start the process and walk you through the remaining steps.',
        },
        {
          question: 'Can you replace my hard drive?',
          answer:
            'ITFixed247 does not repair hardware so if the problem requires hard drive replacement, we can only diagnose the issue.',
        },
        {
          question: 'My computer is very old. Can you help?',
          answer:
            'We can definitely try, but repairing older machines can often end up being more costly than replacing the computer. If your computer is more than 4 years old, consider your options. And, if you need help setting up a new computer, ITFixed247 is here.',
        },
        {
          question: 'Can you help add memory to my computer?',
          answer:
            'Adding memory requires access to the inside of your computer. ITFixed247 does not provide hardware support so if the problem requires additional memory, we can only diagnose the issue.',
        },
      ],
    },
    {
      slug: 'browser-setup',
      cover: '/images/wifi-networking.jpg',
      thumbnail: '',
      title: 'Browsers Setup',
      price: 39,
      descrition:
        'In the ever changing world, browsers have also gone a great transformation. They have become user friendly, fast and cater to the changing needs of the user. It is essential that you choose the correct browser depending upon our requirements. Be it for work or leisure, you can have a variety of browsers in your system. But it is likely that you might face browser related issues like installation problem, compatibility issues, unable to download from internet, online form buttons not functioning, unable to display webpages, frequent disconnection etc. We help you pass through these tough situations easily.',
      services_included: [
        'Browser installation and set up',
        ' Updating the browser',
        ' Installing and updating a new version of the browser',
        ' Browser optimization',
        ' Resolving frequent disconnection problem',
        ' Handling Browser security',
      ],
      faqs: [
        {
          question: 'Does a data transfer or back-up take a long time?',
          answer:
            'The more data you have, the longer your service will take. If you have a very large amount of data, your tech may start the process and walk you through the remaining steps.',
        },
        {
          question: 'Can you replace my hard drive?',
          answer:
            'ITFixed247 does not repair hardware so if the problem requires hard drive replacement, we can only diagnose the issue.',
        },
        {
          question: 'My computer is very old. Can you help?',
          answer:
            'We can definitely try, but repairing older machines can often end up being more costly than replacing the computer. If your computer is more than 4 years old, consider your options. And, if you need help setting up a new computer, ITFixed247 is here.',
        },
        {
          question: 'Can you help add memory to my computer?',
          answer:
            'Adding memory requires access to the inside of your computer. ITFixed247 does not provide hardware support so if the problem requires additional memory, we can only diagnose the issue.',
        },
      ],
    },
    {
      slug: 'application-software',
      cover: '/images/laptop-service.jpg',
      thumbnail: '',
      title: 'Application Software',
      price: 129,
      descrition:
        'For everything today there is differentapplication software. Banking, education, media, finance, hospitality, architecture and many more sectors rely onapplication software. One should know that in application software is one thing that needs to be customized depending upon the needs and requirements of the area. Today various kinds of application software are available for users - office suites, accounting software, file readers, media players, picture viewers, movie makers etc. But even these highly advances applications can give technical glitches that would need the expertise of an experienced technician.        ',
      services_included: [
        ' Installation and setup of application software',
        ' Configuring application software',
        ' Software installation and uninstallation',
        ' Updating and upgrading audio and video software',
        ' Browser software installation',
        ' Software maintenance',
        ' Help and repair',
        ' Resolving all compatibility issues',
        ' Application software security settings',
        ' Timely updates and reviews',
      ],
      faqs: [
        {
          question: 'Does a data transfer or back-up take a long time?',
          answer:
            'The more data you have, the longer your service will take. If you have a very large amount of data, your tech may start the process and walk you through the remaining steps.',
        },
        {
          question: 'Can you replace my hard drive?',
          answer:
            'ITFixed247 does not repair hardware so if the problem requires hard drive replacement, we can only diagnose the issue.',
        },
        {
          question: 'My computer is very old. Can you help?',
          answer:
            'We can definitely try, but repairing older machines can often end up being more costly than replacing the computer. If your computer is more than 4 years old, consider your options. And, if you need help setting up a new computer, ITFixed247 is here.',
        },
        {
          question: 'Can you help add memory to my computer?',
          answer:
            'Adding memory requires access to the inside of your computer. ITFixed247 does not provide hardware support so if the problem requires additional memory, we can only diagnose the issue.',
        },
      ],
    },
  ],
};

export default function (state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
